<template>
  <div>
    <v-layout>
      <v-flex md2>
        <RangeDatePicker
          startDateLabel="Запросы от"
          endDateLabel="Запросы до"
          :startDate.sync="filter.start_at"
          :endDate.sync="filter.end_at"
          @changeRange="filterSupportRequests"
        />
      </v-flex>
      <v-flex md2>
        <Select
          label="Состояние"
          :items="supportRequestsStates"
          v-model="filter.state"
          @change="filterSupportRequests"
          blank
        />
        <Select
          label="Тип"
          :items="supportRequestsConstants"
          v-model="filter.subject"
          item-value="id"
          item-text="name"
          @change="filterSupportRequests"
          blank
        />
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <v-card v-show="!!items.length">
            <v-layout>
                <v-flex md3 class="notifylistRightBlock">
                    <v-flex class="text-md-center justify-center pa-3">
                        <h3>От кого</h3>
                    </v-flex>
                    <v-divider />
                    <ScrollableContainer
                      v-if="!!items.length"
                      @scrollOnBottom="handlerScrollBottom"
                    >
                        <template v-slot:body>
                            <v-list class="notifylistRightBlock__list" v-bind:style="{ maxHeight: MAX_HEIGHT + 'px', overflow: 'auto' }">
                                <v-list-item-group v-model="itemIndex">
                                    <template v-for="item in items">
                                        <v-list-item
                                          :key="item.id"
                                          dense
                                        >
                                            <v-list-item-content>
                                                <v-list-item-title>{{ item.subject.name }} от {{ item.full_name }}</v-list-item-title>
                                                <v-list-item-subtitle>
                                                    <span>{{ item.created_at | dateTime }} | </span>
                                                    <span>{{ item.read_at ? 'Прочитано' : 'Не прочитано' }}</span>
                                                </v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-divider :key="item.created_at"/>
                                    </template>
                                </v-list-item-group>
                            </v-list>
                        </template>
                    </ScrollableContainer>
                </v-flex>
                <v-flex md9 class="pa-0">
                    <v-flex class="text-md-center pa-3">
                        <h3>Сообщение</h3>
                    </v-flex>
                    <v-divider />
                    <v-flex class="pa-2">
                        {{ currentSupportRequest ? currentSupportRequest.message : '' }}
                    </v-flex>
                </v-flex>
            </v-layout>
        </v-card>
        <v-flex v-show="items.length == 0">
          <h3>Нет запросов</h3>
        </v-flex>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import { BASE, FORMAT } from '@/config'
import { ScrollableContainer, RangeDatePicker, Select } from '@/components/common'
import {
  GET_SUPPORT_REQUESTS,
  READ_SUPPORT_REQUEST
} from '@/requests/superadmin'

export default {
  name: 'SupportRequestsSuperAdmin',
  components: {
    ScrollableContainer,
    RangeDatePicker,
    Select
  },
  data() {
    return {
      supportRequestsStates: [
        { text: 'Прочитанные', value: true },
        { text: 'Непрочитанные', value: false },
      ],
      items: [],
      itemIndex: -1,
      limit: BASE.LIMIT,
      endOfData: false,
      currentSupportRequest: null,
      MAX_HEIGHT: 600,
      filter: {
        start_at: null,
        end_at: null,
        state: null,
        subject: null,
      },
      page: -1,
    }
  },
  mounted() {
    this.loadSupportRequests()
  },
  computed: {
    ...mapState({
      supportRequestsConstants: state => state.common.constants.support_requests_types,
    })
  },
  watch: {
    itemIndex: function (itemIndex) {
      this.currentSupportRequest = this.items[itemIndex]
      if (this.currentSupportRequest && !this.currentSupportRequest.read_at) {
        this.readSupportRequest(this.currentSupportRequest.id)
      }
    }
  },
  methods: {
    handlerScrollBottom() {
      if (!this.endOfData) {
        this.loadSupportRequests()
      }
    },
    filterSupportRequests() {
      this.items = []
      this.itemIndex = -1
      this.endOfData = false
      this.page = -1
      this.loadSupportRequests()
    },
    async loadSupportRequests() {
      this.page += 1
      try {
        const { data: { results } } = await GET_SUPPORT_REQUESTS({
          offset: this.limit * this.page,
          limit: this.limit,
          date_from: this.filter.start_at ? moment(this.filter.start_at).format(FORMAT.datepickerDate) : null,
          date_to: this.filter.end_at ? moment(this.filter.end_at).format(FORMAT.datepickerDate) : null,
          is_readed: this.filter.state,
          subject: this.filter.subject,
          ordering: '-id',
        })

        if (results.length) {
          this.items = [...this.items, ...results.map(n => ({
            ...n,
            subject: this.supportRequestsConstants.find(nc => nc.id === n.subject),
            isReaded: !!n.read_at,
            full_name: n.payer.full_name,
          }))]
          if (results.length < this.limit) this.endOfData = true
        } else {
          this.endOfData = true
        }
      } catch (error) {
        console.error(error)
        this.$notify({
          type: 'error',
          text: 'Не удалось получить запросы'
        })
      }
    },
    async readSupportRequest(id) {
      try {
        const { data } = await READ_SUPPORT_REQUEST(id)
        this.items = this.items.map(item => {
          if (item.id !== id) {
              return item
          }
          return {...item, read_at: data.read_at}
        })
      } catch (error) {
        this.$notify({
          type: 'error',
          text: 'Ошибка обновления запроса в техподдержку.'
        })
      }
    }
  }
}
</script>
